import Resolution from 'engine/Resolution.js';

export const NUMBER_TO_RESOLUTION = {
    2: new Resolution(4, false),
    3: new Resolution(4, true), 
    4: new Resolution(8, false), 
    5: new Resolution(8, true), 
    6: new Resolution(16, false), 
    7: new Resolution(16, true), 
    8: new Resolution(32, false), 
    9: new Resolution(32, true), 
};

